import React from "react";
import {
  Dashboard as DashboardIcon,
  Store as StoreIcon,
  MenuBook as MenuBookIcon,
} from "@mui/icons-material";
import SettingsIcon from "@mui/icons-material/Settings";
import CenterFocusWeakIcon from "@mui/icons-material/CenterFocusWeak";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Fireplace from "@mui/icons-material/Fireplace";
import BallotIcon from "@mui/icons-material/Ballot";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
// import BagIcon from "assets/svg/BagIcon";
import { ROUTES } from "shared/constants/routes";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const DRAWER_ITEMS = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    route: ROUTES.DASHBOARD.LINK,
  },
  // {
  //   title: "My Stores",
  //   icon: <StoreIcon />,
  //   // route: ROUTES.MY_STORES.LINK,
  //   childItems: [
  //     {
  //       title: ROUTES.MY_STORES.TITLE,
  //       route: ROUTES.MY_STORES.LINK,
  //     },
  //     {
  //       title: ROUTES.MY_STORES_SYNC_PRODUCTS.TITLE,
  //       route: ROUTES.MY_STORES_SYNC_PRODUCTS.LINK,
  //     },
  //   ],
  //   // childItems: [
  //   //   {
  //   //     title: 'Stores',
  //   //     route: ROUTES.MY_STORES.LINK,
  //   //   },
  //   //   {
  //   //     title: 'Products',
  //   //     route: ROUTES.MY_STORES_PRODUCTS.LINK,
  //   //   },
  //   // ],
  // },
  // {
  //   title: "Orders",
  //   icon: <BagIcon />,
  //   route: ROUTES.ORDERS.LINK,
  // },
  // {
  //   title: "Product & Pricing",
  //   icon: <MenuBookIcon />,
  //   route: ROUTES.CATALOG.LINK,
  // },
  // {
  //   title: "Mock-Up Generator",
  //   icon: <CenterFocusWeakIcon />,
  //   route: ROUTES.MY_STORES_PRODUCTS.LINK,
  //   newRelease: true,
  // },

  // {
  //   title: ROUTES.BACKGROUND_BURNER.TITLE,
  //   icon: <Fireplace />,
  //   route: ROUTES.BACKGROUND_BURNER.LINK,
  //   newRelease: true,
  // },
  {
    title: ROUTES.DTF_TRANSFERS_BY_SIZE.TITLE,
    icon: <LocalPrintshopIcon />,
    route: ROUTES.DTF_TRANSFERS_BY_SIZE.LINK,
    newRelease: true,
  },
  {
    title: ROUTES.DTF_TRANSFERS_GANG_SHEET.TITLE,
    icon: <LocalPrintshopIcon />,
    route: ROUTES.DTF_TRANSFERS_GANG_SHEET.LINK,
    newRelease: true,
  },
  {
    title: ROUTES.DTF_ORDERS.TITLE,
    icon: <AssignmentIcon />,
    route: ROUTES.DTF_ORDERS.LINK,
    newRelease: true,
  },
  // {
  //   icon: <AssessmentIcon />,
  //   title: ROUTES.USER_SALES_REPORT.TITLE,
  //   route: ROUTES.USER_SALES_REPORT.LINK,
  // },
  // {
  //   icon: <BallotIcon />,
  //   title: ROUTES.INVENTORY.TITLE,
  //   route: ROUTES.INVENTORY.LINK,
  //   inventory: true,
  // },
  // {
  //   title: ROUTES.VERIFY_ART_FILES.TITLE,
  //   route: ROUTES.VERIFY_ART_FILES.LINK,
  //   icon: <DoneOutlineIcon />,
  //   newRelease: true,
  // },
  { divider: true },
  {
    title: "Account Settings",
    icon: <SettingsIcon />,
    route: ROUTES.ACCOUNT_SETTINGS.LINK,
  },
];

const getDrawerItems = (emailId) => {
  const isAdmin = emailId === "support@shirtly.com";

  const tempAdmin =
    emailId === "mlamothe@docpartners.ca" || emailId === "west@gowest.ai";

  if (isAdmin) {
    return [
      {
        title: "Admin",
        icon: <SupervisorAccountIcon />,
        childItems: [
          {
            title: ROUTES.WEB_PAGES.TITLE,
            route: ROUTES.WEB_PAGES.LINK,
          },
          {
            title: "Users",
            route: ROUTES.ADMIN_USERS.LINK,
          },
          {
            title: ROUTES.ADMIN_IP_PROGRAM.TITLE,
            route: ROUTES.ADMIN_IP_PROGRAM.LINK,
          },
          {
            title: "All Orders",
            route: ROUTES.WAREHOUSE.LINK,
          },
          {
            title: ROUTES.ADMIN_DTF_ORDERS.TITLE,
            route: ROUTES.ADMIN_DTF_ORDERS.LINK,
          },

          {
            title: "Settings",
            route: ROUTES.ADMIN_SETTINGS.LINK,
          },
          {
            title: ROUTES.ADMIN_DTG_PLUS.TITLE,
            route: ROUTES.ADMIN_DTG_PLUS.LINK,
          },
          {
            title: ROUTES.ADMIN_SCREEN_PRINTING.TITLE,
            route: ROUTES.ADMIN_SCREEN_PRINTING.LINK,
          },
          {
            title: "Products",
            route: ROUTES.ADMIN_EDIT_PRODUCT.LINK,
          },
          // {
          //   title: ROUTES.ADMIN_SALES_REPORT.TITLE,
          //   route: ROUTES.ADMIN_SALES_REPORT.LINK,
          // },
          {
            title: ROUTES.ORDER_STOCK.TITLE,
            route: ROUTES.ORDER_STOCK.LINK,
          },
          {
            title: ROUTES.SUBMITTED_ORDER_STOCK.TITLE,
            route: ROUTES.SUBMITTED_ORDER_STOCK.LINK,
          },
          {
            title: ROUTES.FULFILLMENT_DAYS.TITLE,
            route: ROUTES.FULFILLMENT_DAYS.LINK,
          },
          {
            title: ROUTES.NOTIFICATIONS.TITLE,
            route: ROUTES.NOTIFICATIONS.LINK,
          },
        ],
      },

      // {
      //   title: ROUTES.AI_MOCK_UP_GENERATOR.TITLE,
      //   icon: <AutoAwesomeIcon />,
      //   route: ROUTES.AI_MOCK_UP_GENERATOR.LINK,
      //   newRelease: true,
      // },

      ...DRAWER_ITEMS,
    ];
  }

  if (tempAdmin) {
    return [
      // {
      //   title: ROUTES.AI_MOCK_UP_GENERATOR.TITLE,
      //   icon: <AutoAwesomeIcon />,
      //   route: ROUTES.AI_MOCK_UP_GENERATOR.LINK,
      //   newRelease: true,
      // },

      ...DRAWER_ITEMS,
    ];
  }

  return DRAWER_ITEMS;
};

export { DRAWER_ITEMS, getDrawerItems };
